// Core
import React, { useState } from "react";

// Custom layout
import MainLayout from "../../../Layouts/Main";

//styles
import "./styles.scss";

//router
import {
  NavLink,
  useLocation,
  useNavigate,
  Outlet,
  Link,
} from "react-router-dom";

const ContentManagement = () => {
  const contentManagementNavLinks = [
    {
      to: "productTrainingProgram",
      label: "Product Trainings",
      id: "1",
    },
    {
      to: "industryTrainingPrograms",
      label: "Industry Trainings",
      id: "2",
    },
    {
      to: "bannersAndPromotions",
      label: "Banners/Promotions",
      id: "3",
    },
    {
      to: "faqs",
      label: "FAQ's",
      id: "4",
    },
    {
      to: "offerCodes",
      label: "Offer Code",
      id: "5",
    },
  ];

  return (
    <MainLayout pageName={"Content Management"}>
      <div className="contentManagementContainer">
        <div className="contentNavBar">
          {contentManagementNavLinks.map((option) => (
            <div key={option.id} className="contentOptionContainer">
              <NavLink
                key={option.id}
                to={option.to}
                style={{ textDecoration: "none" }}
                className={({ isActive }) =>
                  isActive
                    ? "active-contentOptionContainerNav"
                    : "contentOptionContainerNav"
                }
              >
                {option.label}
              </NavLink>
            </div>
          ))}
        </div>
        <Outlet />
      </div>
    </MainLayout>
  );
};

export default ContentManagement;
